import { useEffect, useRef, useState } from "react";
import { useSYS3020_R01Store } from "src/containers/mes/SYS/SYS3020_R01/Store_SYS3020_R01";
import { Content_SYS3020_R01 } from "./Content_SYS3020_R01";
import { SearchSection_SYS3020_R01 } from "./SearchSection_SYS3020_R01";
import { Table_SYS3020_R01 } from "./Table_SYS3020_R01";
import { DetailTable_SYS3020_R01 } from "./DetailTable_SYS3020_R01";
import { Message } from "src/components/common/form/Message";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import useUiuxStore from "src/store/useUiuxStore";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { useMouseContent } from "src/utils/mouse/mouseContent";
import SpinnerOverlay from "src/components/common/SpinnerOverlay";
import { AgGridReact } from "ag-grid-react";
import { SYS3020_R01Dto } from "./Dto_SYS3020_R01";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";

export const Container_SYS3020_R01 = () => {
	const {
		allCount,
		initData,
	} = useSYS3020_R01Store();

	const { setMessage } = useUiuxStore();
	const { yesNoList } = useCommonCodeStore();

	// 스플릿(리사이저) 관련
	const RESIZER = {
		code: 'SYS3020_R01',
		type: 'width',
		storageKey: 'SYS3020_R01-split-width',
		min: 10,
		max: 90,
		default: 33,
	} as const;

	const gridRef = useRef<AgGridReact<SysCodeDto>>(null);
	const detailGridRef = useRef<AgGridReact<SYS3020_R01Dto>>(null);

	const containerRef = useRef<HTMLDivElement>(null);
	const detailRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);



	const { splitValue, handleMouseDown } = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef: detailRef,
	});

	// Content에서 핸들러 함수들 가져오기
	const {
		handleExcelClick,
		defaultSYS3020_R01DetailRow,
		fetchData,
		fetchMenuAuthorityData,
		initContainerData,
		handleSaveClick,
		handleDeleteClick,
		handleTableRowClick,
	} = Content_SYS3020_R01({ 
		gridRef,
		detailGridRef,
		setMessage,
		
	});



	return (
		<div className="content-container">      
			<Actionbar
				onFetchClick={fetchData}
				onCreateClick={() => {}}
				onDeleteClick={handleDeleteClick}
				onSaveClick={handleSaveClick}
				onExcelClick={handleExcelClick}
				onInitClick={initContainerData}
			/>
			
			{/* 검색/필터 영역 */}
			<SearchSection_SYS3020_R01 
				yesnoOptions={yesNoList}
				fetchData={fetchData}
			/>
			
			<div className="flex-1 flex gap-[4px] p-[12px]" ref={containerRef}>
				<div className="h-full" style={{ width: `${splitValue}%` }}>
					<Table_SYS3020_R01 onRowClick={handleTableRowClick} gridRef={gridRef} />
				</div> 
				
				{/* 리사이저 */}
				<div
					className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
					onMouseDown={(e) => handleMouseDown('LR', e.nativeEvent)}
				/>
				
				<div className="h-full" style={{ width: `${100 - splitValue}%` }} ref={detailRef}>
					<DetailTable_SYS3020_R01 gridRef={detailGridRef} defaultSYS3020_R01DetailRow={defaultSYS3020_R01DetailRow()} />
				</div>
			</div>
			
			<Message />
		</div>
	);
};

export default Container_SYS3020_R01; 